export default __webpack_public_path__ + "static/phblgrphr-logo-b7f2d202574580a4cd3cd55e23d633fe.png";